export default __webpack_public_path__ + "2f111bb081cc6dcb17c35bfe79c2bf6b.png";